import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { OrdersCountMetadata } from '@compumark/order-management-client';
import { Observable } from 'rxjs';

import { OrdersApiClientService } from '../../services/orders.api.client.service';

@Injectable()
export class OrdersCountMetadataResolver
  implements Resolve<OrdersCountMetadata>
{
  private ordersService = inject(OrdersApiClientService);

  resolve(route: ActivatedRouteSnapshot): Observable<OrdersCountMetadata> {
    return this.ordersService.countOrders(
      route.paramMap.get('status') as 'active' | 'inactive',
    );
  }
}
